import { NumberField, NumberFieldProps } from './number-field';
import { FieldValues, Path } from 'react-hook-form';

export interface ManufacturerCalcFieldProps<T extends FieldValues = FieldValues>
  extends Omit<NumberFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const ManufacturerCalcField = <T extends FieldValues = FieldValues>({
  name = 'manufactureCalc' as Path<T>,
  ...rest
}: ManufacturerCalcFieldProps<T>) => {
  return <NumberField name={name} {...rest} isSmallSize allowNegative={false} />;
};
